var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7454 8.47087L12.3912 0.157564C12.1722 -0.00271666 11.8748 -0.00271666 11.6559 0.157564L0.301639 8.47087C0.0243056 8.67396 -0.0359517 9.06339 0.167136 9.34072C0.370224 9.61806 0.759697 9.67822 1.03698 9.47522L12.0235 1.43106L23.01 9.47518C23.1208 9.55635 23.2496 9.59541 23.3772 9.59541C23.5688 9.59541 23.7579 9.50723 23.8798 9.34068C24.083 9.06339 24.0227 8.67396 23.7454 8.47087Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7363 9.61609C20.3927 9.61609 20.114 9.89473 20.114 10.2385V20.1448H15.1352V14.7373C15.1352 13.0213 13.7391 11.6253 12.0231 11.6253C10.3072 11.6253 8.91108 13.0214 8.91108 14.7373V20.1449H3.93223V10.2385C3.93223 9.89478 3.65354 9.61614 3.30986 9.61614C2.96619 9.61614 2.6875 9.89478 2.6875 10.2385V20.7673C2.6875 21.111 2.96619 21.3897 3.30986 21.3897H9.53344C9.86074 21.3897 10.1286 21.1368 10.1534 20.8158C10.1549 20.8012 10.1558 20.7853 10.1558 20.7673V14.7374C10.1558 13.7077 10.9935 12.87 12.0231 12.87C13.0528 12.87 13.8904 13.7077 13.8904 14.7374V20.7673C13.8904 20.7852 13.8914 20.8008 13.8929 20.8152C13.9174 21.1365 14.1853 21.3897 14.5128 21.3897H20.7364C21.0801 21.3897 21.3588 21.111 21.3588 20.7673V10.2385C21.3587 9.89473 21.0801 9.61609 20.7363 9.61609Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.ce3aae71.svg";
export { ForwardRef as ReactComponent };